<div class="form-container">

  <div class="form-header">
    <button
      type="button"
      class="back-link"
      (click)="onCancel()"
    >
      &lt; Volver atrás
    </button>

    <h1 class="page-title">
      {{ editingProductId ? 'Editar Producto' : 'Añadir Producto' }}
    </h1>
    <span class="stock-badge" [class.out]="isProductOutOfStock()">
      {{ isProductOutOfStock() ? 'Sin stock' : 'Con stock' }}
    </span>
  </div>

  <form
    [formGroup]="productForm"
    (ngSubmit)="onSubmit()"
    class="product-form"
  >
    <div class="form-section grid-2-col">
      <div class="form-group">
        <label for="product-name">Nombre del Producto</label>
        <input
          type="text"
          id="product-name" formControlName="name"
          placeholder="Ej: Bluey Articulado"
        >

        @if (
          productForm.get('name')?.invalid &&
          productForm.get('name')?.touched
        ) {
          <span class="error-msg">
            El nombre es requerido
          </span>
        }
      </div>

      <div class="form-group">
        <label for="product-description">Descripción del producto <span class="label-optional">(opcional)</span></label>

        <textarea
          id="product-description" formControlName="description"
          placeholder="Ej: Bluey Articulado..."
          rows="3"
        ></textarea>
      </div>

      <div class="form-group">
        <label for="product-categoryId">Categoría *</label>

        <select id="product-categoryId" formControlName="categoryId">
          <option value="" disabled selected>
            Seleccionar
          </option>

          @for (cat of mainCategories(); track cat.id) {
            <option [value]="cat.id">
              {{ cat.name }}
            </option>
          }
        </select>

        @if (
          productForm.get('categoryId')?.invalid &&
          productForm.get('categoryId')?.touched
        ) {
          <span class="error-msg">
            ⚠️ Debes seleccionar una categoría
          </span>
        }

        @if (productForm.get('categoryId')?.value === merchandisingCategoryId) {
          <small class="merchandising-notice" role="note">
            Este producto se publicará como merchandising: no se vende por el carrito,
            muestra precios al por mayor y el cliente solicita una cotización.
          </small>
        }
      </div>

      <div class="form-group">
        <label for="product-status">Estado</label>

        <select id="product-status" formControlName="status">
          <option value="coming_soon">Próximamente</option>
          <option value="active">Activo</option>
          <option value="inactive">Inactivo</option>
        </select>
      </div>

      <div class="form-group">
        <label for="product-subCategoryId">Sub Categoría</label>

        <select id="product-subCategoryId" formControlName="subCategoryId">
          <option value="" disabled selected>
            Seleccionar
          </option>

          @for (sub of subCategories(); track sub.id) {
            <option [value]="sub.id">
              {{ sub.name }}
            </option>
          }
        </select>

        @if (
          mainCategories().length > 0 &&
          !productForm.get('categoryId')?.value
        ) {
          <small
            style="
              color: #666;
              font-size: 0.8rem;
              display: block;
              margin-top: 4px;
            "
          >
            Selecciona una categoría primero
          </small>
        }
      </div>

    </div>

    <div class="form-section">
      <h3>Precio</h3>

      <div class="form-group">
        <label class="checkbox-label">
          <input type="checkbox" formControlName="useSizeVariations">
          Usar variaciones por tamaño
        </label>
      </div>

      @if (!useSizeVariations) {
        <div class="form-group">
          <label for="product-basePrice">Precio base</label>
          <input
            #basePriceInput
            inputmode="numeric"
            type="text"
            id="product-basePrice" formControlName="basePrice"
            placeholder="Precio (Ej: 8.000)"
            (input)="onPriceInput($event, 'basePrice')"
            (blur)="onPriceBlur($event, 'basePrice')"
            aria-describedby="base-price-error"
          >
          @if (productForm.get('basePrice')?.invalid && productForm.get('basePrice')?.touched) {
            <span class="error-msg" id="base-price-error">Ingresa un precio mayor a 0.</span>
          }
        </div>

        <div class="form-group shipping-dimensions" formGroupName="baseDimensions">
          <span class="shipping-dimensions__title">Envío: peso y medidas del producto</span>

          <label class="pickup-only-toggle">
            <input type="checkbox" formControlName="isPickupOnly" (change)="applyPickupOnlyState(baseDimensionsGroup)">
            Solo retiro en tienda (sin despacho a domicilio)
          </label>
          @if (isPickupOnly(baseDimensionsGroup)) {
            <span class="shipping-disabled-msg">Este producto no tendrá envío a domicilio: solo retiro en tienda.</span>
          } @else {
            <div class="dimensions-row">
              <label>Peso (g)
                <input type="number" min="1" max="1000000" step="1" inputmode="numeric" formControlName="weightGrams" placeholder="Ej: 250" [attr.aria-describedby]="'base-weightGrams-error'">
                @if (baseDimensionsGroup.get('weightGrams')?.invalid && baseDimensionsGroup.get('weightGrams')?.touched) {
                  <span class="error-msg" [id]="'base-weightGrams-error'">Ingresa un número entero entre 1 y 1.000.000.</span>
                }
              </label>
              <label>Largo (cm)
                <input type="number" min="1" max="200" step="1" inputmode="numeric" formControlName="lengthCm" placeholder="Ej: 12" [attr.aria-describedby]="'base-lengthCm-error'">
                @if (baseDimensionsGroup.get('lengthCm')?.invalid && baseDimensionsGroup.get('lengthCm')?.touched) {
                  <span class="error-msg" [id]="'base-lengthCm-error'">Ingresa un número entero entre 1 y 200.</span>
                }
              </label>
              <label>Ancho (cm)
                <input type="number" min="1" max="200" step="1" inputmode="numeric" formControlName="widthCm" placeholder="Ej: 10" [attr.aria-describedby]="'base-widthCm-error'">
                @if (baseDimensionsGroup.get('widthCm')?.invalid && baseDimensionsGroup.get('widthCm')?.touched) {
                  <span class="error-msg" [id]="'base-widthCm-error'">Ingresa un número entero entre 1 y 200.</span>
                }
              </label>
              <label>Alto (cm)
                <input type="number" min="1" max="200" step="1" inputmode="numeric" formControlName="heightCm" placeholder="Ej: 15" [attr.aria-describedby]="'base-heightCm-error'">
                @if (baseDimensionsGroup.get('heightCm')?.invalid && baseDimensionsGroup.get('heightCm')?.touched) {
                  <span class="error-msg" [id]="'base-heightCm-error'">Ingresa un número entero entre 1 y 200.</span>
                }
              </label>
            </div>
            <p class="dimensions-hint">Solo números enteros, sin decimales. Mide el producto ya embalado y redondea hacia arriba: 12,3 cm → 13 cm; 0,5 g → 1 g. El peso va en gramos: 1,5 kg = 1500. Máximo 200 cm por lado y 1.000 kg.</p>
            @if (getShippingFitWarning(baseDimensionsGroup); as shippingFitWarning) {
              <p class="shipping-fit-warning" role="alert">
                <strong>Este producto no se podrá despachar:</strong> {{ shippingFitWarning }}
                Si lo guardas así, solo se podrá retirar en tienda. Revisa las medidas o agrega una caja más grande en "Cajas de envío".
              </p>
            }
          }
        </div>
      } @else {
        <div formArrayName="sizes" class="variations-list">
          @for (sizeCtrl of sizesFormArray.controls; track sizeCtrl) {
            <div [formGroupName]="$index" class="variation-item variation-card">
              <div class="variation-card__header">
                <span class="variation-card__title">Tamaño {{ $index + 1 }}</span>
                <button
                  type="button"
                  class="btn-remove"
                  [attr.aria-label]="'Quitar tamaño ' + ($index + 1)"
                  (click)="removeSize($index)"
                >
                  Quitar
                </button>
              </div>

              <div class="variation-card__fields">
                <label class="variation-field">
                  Tamaño (público)
                  <input
                    type="text"
                    formControlName="label"
                    placeholder="Ejemplos: 1cm, 0.5cm, 1mm, 1.5m"
                  >
                  @if (
                    sizeCtrl.get('label')?.invalid &&
                    sizeCtrl.get('label')?.touched
                  ) {
                    <span class="error-msg">
                      Formato inválido. Ej: 1cm, 0.5cm, 1mm, 1.5m
                    </span>
                  }
                </label>

                <label class="variation-field">
                  Precio unitario
                  <input
                    #sizePriceInput
                    inputmode="numeric"
                    type="text"
                    formControlName="price"
                    placeholder="Precio (Ej: 8.000)"
                    (input)="onPriceInput($event, ['sizes', $index, 'price'])"
                    (blur)="onPriceBlur($event, ['sizes', $index, 'price'])"
                    [attr.aria-describedby]="'size-price-error-' + $index"
                  >
                  @if (sizeCtrl.get('price')?.invalid && sizeCtrl.get('price')?.touched) {
                    <span class="error-msg" [id]="'size-price-error-' + $index">Ingresa un precio mayor a 0.</span>
                  }
                </label>
              </div>

              <div class="variation-card__shipping">
                <span class="variation-card__subtitle">Envío: peso y medidas</span>
                <br>
                <label class="pickup-only-toggle">
                  <input type="checkbox" formControlName="isPickupOnly" (change)="applyPickupOnlyState($any(sizeCtrl))">
                  Solo retiro en tienda (sin despacho a domicilio)
                </label>
                @if (isPickupOnly($any(sizeCtrl))) {
                  <span class="shipping-disabled-msg">Este tamaño no tendrá envío a domicilio: solo retiro en tienda.</span>
                } @else {
                  <div class="dimensions-row">
                    <label>Peso (g)
                <input type="number" min="1" max="1000000" step="1" inputmode="numeric" formControlName="weightGrams" placeholder="Ej: 250" [attr.aria-describedby]="'size-weightGrams-error-' + $index">
                @if (sizeCtrl.get('weightGrams')?.invalid && sizeCtrl.get('weightGrams')?.touched) {
                  <span class="error-msg" [id]="'size-weightGrams-error-' + $index">Ingresa un número entero entre 1 y 1.000.000.</span>
                }
              </label>
                    <label>Largo (cm)
                <input type="number" min="1" max="200" step="1" inputmode="numeric" formControlName="lengthCm" placeholder="Ej: 12" [attr.aria-describedby]="'size-lengthCm-error-' + $index">
                @if (sizeCtrl.get('lengthCm')?.invalid && sizeCtrl.get('lengthCm')?.touched) {
                  <span class="error-msg" [id]="'size-lengthCm-error-' + $index">Ingresa un número entero entre 1 y 200.</span>
                }
              </label>
                    <label>Ancho (cm)
                <input type="number" min="1" max="200" step="1" inputmode="numeric" formControlName="widthCm" placeholder="Ej: 10" [attr.aria-describedby]="'size-widthCm-error-' + $index">
                @if (sizeCtrl.get('widthCm')?.invalid && sizeCtrl.get('widthCm')?.touched) {
                  <span class="error-msg" [id]="'size-widthCm-error-' + $index">Ingresa un número entero entre 1 y 200.</span>
                }
              </label>
                    <label>Alto (cm)
                <input type="number" min="1" max="200" step="1" inputmode="numeric" formControlName="heightCm" placeholder="Ej: 15" [attr.aria-describedby]="'size-heightCm-error-' + $index">
                @if (sizeCtrl.get('heightCm')?.invalid && sizeCtrl.get('heightCm')?.touched) {
                  <span class="error-msg" [id]="'size-heightCm-error-' + $index">Ingresa un número entero entre 1 y 200.</span>
                }
              </label>
                  </div>
                  <p class="dimensions-hint">Solo números enteros, sin decimales. Mide el producto ya embalado y redondea hacia arriba: 12,3 cm → 13 cm; 0,5 g → 1 g. El peso va en gramos: 1,5 kg = 1500. Máximo 200 cm por lado y 1.000 kg.</p>
                  @if (getShippingFitWarning($any(sizeCtrl)); as shippingFitWarning) {
                    <p class="shipping-fit-warning" role="alert">
                      <strong>Este tamaño no se podrá despachar:</strong> {{ shippingFitWarning }}
                      Si lo guardas así, solo se podrá retirar en tienda. Revisa las medidas o agrega una caja más grande en "Cajas de envío".
                    </p>
                  }
                }
              </div>
            </div>
          }
        </div>

        <button
          type="button"
          class="btn-add"
          (click)="addSize()"
        >
          Agregar tamaño
        </button>
      }

    </div>

    <div class="form-section">

      <h3>Variaciones por Color</h3>

      <div
        formArrayName="colors"
        class="variations-list"
      >
        @for (colorCtrl of colorsFormArray.controls; track colorCtrl) {

          <div
            [formGroupName]="$index"
            class="variation-row color-selection-row"
          >

            <select
              formControlName="colorId"
              [attr.aria-label]="'Color ' + ($index + 1)"
              class="color-select"
            >
              <option value="" disabled>
                Seleccionar color
              </option>

              <option value="none">Sin color</option>

              @for (color of getAvailableColorsForRow($index); track color.id) {
                <option [value]="color.id">
                  {{ color.name }}
                </option>
              }
            </select>

            @if (colorCtrl.get('colorId')?.value && colorCtrl.get('colorId')?.value !== 'none') {
              <span class="status-label" [class.out-of-stock]="!getColorIsAvailable(colorCtrl.get('colorId')?.value)">
                {{ getColorIsAvailable(colorCtrl.get('colorId')?.value) ? 'Con stock' : 'Sin stock' }}
              </span>
            }

            <div
              class="color-preview-box"
              [ngStyle]="getColorSwatchStyle(colorCtrl.get('colorId')?.value)"
            ></div>

            <button
              type="button"
              class="btn-remove"
              [attr.aria-label]="'Quitar color ' + ($index + 1)"
              (click)="removeColor($index)"
            >
              Quitar
            </button>

          </div>
        }
      </div>

      <button
        type="button"
        class="btn-add"
        (click)="addColor()"
      >
        Agregar Color +
      </button>

    </div>

    <div class="form-section">
      <h3>Fotos</h3>
      <p class="form-hint">Agrega al menos una foto. La primera será la imagen de portada.</p>
      <app-image-uploader
        [maxImages]="4"
        [initialUrls]="existingImageUrls()"
        [optimizeForCatalog]="true"
        (imagesChange)="onImagesUpdated($event)"
      ></app-image-uploader>
    </div>

    @if (formErrors.length > 0) {
      <div class="form-errors">
        <h4>Hay errores en el formulario:</h4>
        <ul>
          @for (errorMsg of formErrors; track errorMsg) {
            <li>{{ errorMsg }}</li>
          }
        </ul>
      </div>
    }

    <div class="form-actions">
      @if (editingProductId) {
        <button
          type="button"
          class="btn-danger"
          (click)="onDeleteProductClick()"
        >
          Eliminar producto
        </button>
      } @else {
        <button
          type="button"
          class="btn-danger"
          (click)="onClearFormClick()"
        >
          Limpiar formulario
        </button>
      }

      <div class="action-group">
        <button
          type="button"
          class="btn-outline"
          (click)="onCancel()"
        >
          Cancelar
        </button>

        <button
          type="submit"
          class="btn-primary"
          [disabled]="!canSubmit"
        >
          {{ isSubmitting() ? 'Guardando...' : 'Guardar cambios' }}
        </button>
      </div>
    </div>
  </form>
</div>
